<template>
    <div>
        <b-form @submit.prevent="submitProfile(false)">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Агентская компания *">
                        <b-form-select 
                            v-model="form.agent_company_id" 
                            :options="agentCompanySelectOptions" 
                            required
                            :disabled="isAgentAccount || !!agent_settlement.id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Название операции *">
                        <b-form-input v-model="form.title" required placeholder="Например: Бонус за новый заказ"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="Описание">
                        <b-form-textarea v-model="form.description" placeholder="Подробное описание операции" rows="3"></b-form-textarea>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Маржа (₽)">
                        <b-form-input 
                            v-model="form.margin_base" 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Комиссия (%)">
                        <b-form-input 
                            v-model="form.commission_rate" 
                            type="number" 
                            step="0.01" 
                            min="0" 
                            max="100" 
                            placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Сумма *">
                        <b-form-input 
                            v-model="form.amount" 
                            type="number" 
                            step="0.01" 
                            min="0.01" 
                            required 
                            placeholder="1000.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Тип операции *">
                        <b-form-select v-model="form.operation_type" :options="operationTypeOptions" required></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Тип взаиморасчета *">
                        <b-form-select v-model="form.settlement_type" :options="settlementTypeOptions" required></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Статус *">
                        <b-form-select v-model="form.status" :options="statusOptions" required></b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group label="ID заказа (необязательно)">
                        <b-form-input 
                            v-model.number="form.order_id" 
                            type="number" 
                            min="1" 
                            placeholder="Введите ID заказа"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- Показываем информацию о создателе и утвердителе только при редактировании -->
                <template v-if="agent_settlement.id">
                    <b-col cols="6">
                        <b-form-group label="Создатель">
                            <b-form-input :value="form.creator && form.creator.name ? form.creator.name : ''" readonly></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label="Утвердитель">
                            <b-form-input :value="form.approver && form.approver.name ? form.approver.name : ''" readonly></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6" v-if="form.approved_at">
                        <b-form-group label="Дата утверждения">
                            <b-form-input v-model="form.approved_at" readonly></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6" v-if="form.completed_at">
                        <b-form-group label="Дата выполнения">
                            <b-form-input v-model="form.completed_at" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                </template>

                <!-- Кнопки действий для утверждения/отклонения/выполнения -->
                <template v-if="agent_settlement.id && canManageSettlement">
                    <b-col cols="12">
                        <hr>
                        <h6>Действия с операцией:</h6>
                    </b-col>

                    <b-col cols="4" v-if="agent_settlement.status === 'pending'">
                        <b-button 
                            variant="success" 
                            block 
                            @click="approveSettlement"
                            :disabled="loading"
                        >
                            <b-spinner small v-if="loading"></b-spinner>
                            Одобрить
                        </b-button>
                    </b-col>

                    <b-col cols="4" v-if="agent_settlement.status === 'pending'">
                        <b-button 
                            variant="danger" 
                            block 
                            @click="rejectSettlement"
                            :disabled="loading"
                        >
                            <b-spinner small v-if="loading"></b-spinner>
                            Отклонить
                        </b-button>
                    </b-col>

                    <b-col cols="4" v-if="agent_settlement.status === 'approved'">
                        <b-button 
                            variant="primary" 
                            block 
                            @click="completeSettlement"
                            :disabled="loading"
                        >
                            <b-spinner small v-if="loading"></b-spinner>
                            Выполнить
                        </b-button>
                    </b-col>
                </template>
            </b-row>

            <hr>

            <div class="d-flex justify-content-between">
                <b-button variant="secondary" @click="$emit('closed')">
                    Отмена
                </b-button>
                <div>
                    <b-button 
                        type="submit" 
                        variant="primary" 
                        :disabled="loading"
                    >
                        <b-spinner small v-if="loading"></b-spinner>
                        {{ agent_settlement.id ? 'Обновить' : 'Создать' }}
                    </b-button>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import { API_AGENT_SETTLEMENTS, API_AGENT_COMPANY } from "@/constants";
    import { mapGetters } from 'vuex';

    export default {
        props: {
            agent_settlement: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                form: {
                    id: null,
                    agent_company_id: null,
                    title: '',
                    description: '',
                    margin_base: 0,
                    commission_rate: 0,
                    amount: 0,
                    operation_type: 'debit',
                    status: 'pending',
                    order_id: null,
                    creator_user_id: null,
                    approver_user_id: null,
                    settlement_type: 'other',
                    metadata: {},
                    approved_at: null,
                    completed_at: null,
                    agent_company: {},
                    order: {},
                    creator: {},
                    approver: {}
                },
                agentCompanyOptions: [],
                operationTypeOptions: [
                    { value: 'debit', text: 'Дебет (начисление)' },
                    { value: 'credit', text: 'Кредит (списание)' }
                ],
                settlementTypeOptions: [
                    { value: 'bonus', text: 'Бонус' },
                    { value: 'order_commission', text: 'Комиссия за заказ' },
                    { value: 'withdrawal', text: 'Вывод средств' },
                    { value: 'penalty', text: 'Штраф' },
                    { value: 'correction', text: 'Корректировка' },
                    { value: 'other', text: 'Прочее' }
                ],
                statusOptions: [
                    { value: 'pending', text: 'Ожидает одобрения' },
                    { value: 'approved', text: 'Одобрено' },
                    { value: 'rejected', text: 'Отклонено' },
                    { value: 'completed', text: 'Выполнено' }
                ]
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser']),
            agentCompanySelectOptions() {
                if (this.agent_settlement.id) {
                    const id = this.form.agent_company_id;
                    if (!id) {
                        return [];
                    }

                    const company = this.form.agent_company || this.agent_settlement.agent_company || {};

                    return [
                        {
                            value: id,
                            text: this.formatAgentCompanyOption(company, id)
                        }
                    ];
                }

                return this.agentCompanyOptions;
            },
            isAgentAccount() {
                const userRoles = this.currentUser?.roles || [];
                return userRoles.some(role => role.slug === 'agent');
            },
            canManageSettlement() {
                const userRoles = this.currentUser?.roles || [];
                const roleSlugs = userRoles.map(role => role.slug);
                
                // Администраторы и менеджеры могут управлять операциями
                return roleSlugs.some(role => 
                    ['administrator', 'president', 'sales-head-manager', 'logistics-head-manager', 'TO-head-manager', 'accountant', 'head-accountant'].includes(role)
                );
            }
        },
        watch: {
            agent_settlement: {
                handler(newVal) {
                    this.initializeForm();
                },
                immediate: true
            }
        },
        mounted() {
            this.loadAgentCompanies();
        },
        methods: {
            initializeForm() {
                if (this.agent_settlement.id) {
                    // Редактирование существующей операции
                    const src = this.agent_settlement || {};
                    this.form = {
                        ...src,
                        margin_base: src.margin_base ?? 0,
                        commission_rate: src.commission_rate ?? 0,
                        creator: src.creator || {},
                        approver: src.approver || {},
                        agent_company: src.agent_company || {},
                        order: src.order || {},
                    };
                } else {
                    // Создание новой операции
                    this.form = {
                        id: null,
                        agent_company_id: this.isAgentAccount ? this.getCurrentUserAgentCompanyId() : null,
                        title: '',
                        description: '',
                        margin_base: 0,
                        commission_rate: 0,
                        amount: 0,
                        operation_type: 'debit',
                        status: 'pending',
                        order_id: null,
                        creator_user_id: null,
                        approver_user_id: null,
                        settlement_type: 'other',
                        metadata: {},
                        approved_at: null,
                        completed_at: null,
                        agent_company: {},
                        order: {},
                        creator: {},
                        approver: {}
                    };
                }
            },
            getCurrentUserAgentCompanyId() {
                // Получаем агентскую компанию из store
                const agentCompany = this.$store.getters['auth/getAgentCompany'];
                return agentCompany ? agentCompany.id : null;
            },
            async loadAgentCompanies() {
                try {
                    const response = await api.call('get', API_AGENT_COMPANY);
                    this.agentCompanyOptions = response.data.data.map(company => ({
                        value: company.id,
                        text: this.formatAgentCompanyOption(company, company.id)
                    }));
                } catch (error) {
                    console.error('Ошибка загрузки агентских компаний:', error);
                }
            },
            
            async submitProfile() {
                this.loading = true;
                
                try {
                    const payload = this.prepareSubmitPayload();

                    let response;
                    if (this.form.id) {
                        // Обновление
                        response = await api.call('put', `${API_AGENT_SETTLEMENTS}/${this.form.id}`, payload);
                    } else {
                        // Создание
                        response = await api.call('post', API_AGENT_SETTLEMENTS, payload);
                    }
                    
                    this.$emit('updated', response.data);
                    this.makeToast('success', this.form.id ? 'Операция обновлена' : 'Операция создана');
                    
                } catch (error) {
                    console.error('Ошибка сохранения:', error);
                    this.makeToast('danger', 'Ошибка сохранения операции');
                } finally {
                    this.loading = false;
                }
            },
            async approveSettlement() {
                this.loading = true;
                try {
                    const response = await api.call('post', `${API_AGENT_SETTLEMENTS}/${this.form.id}/approve`);
                    this.$emit('updated', response.data.data);
                    this.makeToast('success', 'Операция одобрена');
                } catch (error) {
                    console.error('Ошибка одобрения:', error);
                    this.makeToast('danger', 'Ошибка одобрения операции');
                } finally {
                    this.loading = false;
                }
            },
            async rejectSettlement() {
                this.loading = true;
                try {
                    const response = await api.call('post', `${API_AGENT_SETTLEMENTS}/${this.form.id}/reject`);
                    this.$emit('updated', response.data.data);
                    this.makeToast('success', 'Операция отклонена');
                } catch (error) {
                    console.error('Ошибка отклонения:', error);
                    this.makeToast('danger', 'Ошибка отклонения операции');
                } finally {
                    this.loading = false;
                }
            },
            async completeSettlement() {
                this.loading = true;
                try {
                    const response = await api.call('post', `${API_AGENT_SETTLEMENTS}/${this.form.id}/complete`);
                    this.$emit('updated', response.data.data);
                    this.makeToast('success', 'Операция выполнена');
                } catch (error) {
                    console.error('Ошибка выполнения:', error);
                    this.makeToast('danger', 'Ошибка выполнения операции');
                } finally {
                    this.loading = false;
                }
            },
            makeToast(variant, message) {
                this.$bvToast.toast(message, {
                    title: variant === 'success' ? 'Успешно' : 'Ошибка',
                    variant: variant,
                    solid: true
                });
            },
            formatAgentCompanyOption(company, id) {
                if (!id) {
                    return '';
                }

                const fullName = company?.full_name || company?.name || '';
                const inn = company?.inn;

                const parts = [];

                if (fullName) {
                    parts.push(fullName);
                }

                parts.push(`ID: ${id}`);

                if (inn) {
                    parts.push(`ИНН: ${inn}`);
                }

                return parts.join(' | ');
            },
            prepareSubmitPayload() {
                const payload = { ...this.form };

                ['agent_company', 'order', 'creator', 'approver'].forEach(field => {
                    if (field in payload) {
                        delete payload[field];
                    }
                });

                ['approved_at', 'completed_at', 'created_at', 'updated_at'].forEach(field => {
                    if (payload[field]) {
                        payload[field] = this.normalizeDateTime(payload[field]);
                    }
                });

                return payload;
            },
            normalizeDateTime(value) {
                if (!value) {
                    return value;
                }

                if (value instanceof Date) {
                    const year = value.getFullYear();
                    const month = String(value.getMonth() + 1).padStart(2, '0');
                    const day = String(value.getDate()).padStart(2, '0');
                    const hours = String(value.getHours()).padStart(2, '0');
                    const minutes = String(value.getMinutes()).padStart(2, '0');
                    const seconds = String(value.getSeconds()).padStart(2, '0');
                    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }

                if (typeof value === 'string') {
                    const trimmed = value.trim();

                    if (!trimmed) {
                        return null;
                    }

                    // ISO 8601 формат
                    if (trimmed.includes('T')) {
                        return trimmed.replace('T', ' ').substring(0, 19);
                    }

                    const match = trimmed.match(/^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
                    if (match) {
                        const [, day, month, year, hours = '00', minutes = '00', seconds = '00'] = match;
                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                    }

                    const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
                    if (isoMatch) {
                        const [, year, month, day, hours = '00', minutes = '00', seconds = '00'] = isoMatch;
                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                    }
                }

                return value;
            }
        }
    }
</script> 